import React, { useState, useEffect } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap"
import SButton from "components/Common/Button"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import Skeleton from "react-loading-skeleton"
import FabricInventoryAction from "store/fabric-inventory-resource/actions"
import ModalDetailRow from "./ModalDetailRow"
import { toast } from "react-toastify"
import TableContainer from "components/newTables/TableContainer"

export default function FabricInventoryManagement() {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(state => state)
  const [pagination, setPagination] = React.useState({
    page: 0,
    size: 10,
  })
  const [params, setParams] = React.useState({
    page: 0,
    size: 10,
  })
  const [filter, setFilter] = useState({
    bunch: "",
    brand: "",
    number: "",
    companyName: "",
  })

  const [selectedToAdd, setSelectedToAdd] = React.useState([])
  const [open, setOpen] = React.useState(false)
  const [selectedId, setSelectedId] = React.useState("")

  const toggle = id => {
    if (typeof id == "number") {
      setSelectedId(id)
    } else {
      setSelectedId("")
    }
    setOpen(!open)
  }

  const [tempDataDetail, setTempDataDetail] = useState()

  const callbackGetPageDetail = data => {
    if (data.content.length > 0) {
      selectedToAdd.forEach(s => {
        data.content.forEach(d => {
          if (s.orderId === d.orderId) {
            d.selected = s.selected
          }
        })
      })
    }
    setPararmDetail({ page: 0, size: 10 })
    setTempDataDetail(data)
    toggle(data.parentId)
  }
  const callbackGetPageDetailModal = data => {
    setTempDataDetail(data)
    if (data.content.length > 0) {
      selectedToAdd.forEach(s => {
        data.content.forEach(d => {
          if (s.orderId === d.orderId) {
            d.selected = s.selected
          }
        })
      })
    }
    setTempDataDetail(data)
    // toggle(data.parentId)
  }

  const [pararmDetail, setPararmDetail] = useState({ page: 0, size: 10 })

  useEffect(() => {
    if (selectedId) {
      dispatch(
        FabricInventoryAction.getDetailPage(
          { id: selectedId, ...pararmDetail },
          callbackGetPageDetailModal
        )
      )
    }
  }, [pararmDetail])

  const columns = React.useMemo(
    () => [
      {
        Header: "生地商社",
        accessor: "companyName",
        defaultCanSort: false,
      },
      {
        Header: "バンチ",
        accessor: "bunch",
        defaultCanSort: false,
      },
      {
        Header: "ブランド",
        accessor: "brand",
        defaultCanSort: false,
      },
      {
        Header: "生地番号",
        accessor: "number",
        defaultCanSort: false,
      },
      {
        Header: "実在庫数",
        accessor: "actualInventory",
        defaultCanSort: false,
      },
      {
        Header: "引き当て",
        accessor: "allocation",
        defaultCanSort: false,
      },
      {
        Header: "発注可能数",
        accessor: "theoreticalStock",
        defaultCanSort: false,
        Cell: ({ cell }) => (
          <span>
            {Math.abs(
              cell.row.original.actualInventory - cell.row.original.allocation
            )}
          </span>
        ),
      },
      {
        Header: "現在発注数",
        accessor: "currentOrderQuantity",
        defaultCanSort: false,
      },
      {
        Header: "",
        accessor: "select",
        defaultCanSort: false,
        Cell: ({ cell }) => (
          <Button
            className="btn-sm button"
            onClick={() => {
              dispatch(
                FabricInventoryAction.getDetailPage(
                  { id: cell.row.original.id, page: 0, size: 10 },
                  callbackGetPageDetail
                )
              )
              // toggle(cell.row.original.id)
            }}
          >
            引き当て詳細
          </Button>
        ),
      },
      {
        Header: "",
        accessor: "name",
        defaultCanSort: false,
        Cell: ({ cell }) => (
          <Button
            className="btn-sm button"
            onClick={() =>
              history.push(
                `/inventory-control/fabric-inventory-management/${cell.row.original.id}`
              )
            }
          >
            調整
          </Button>
        ),
      },
    ],
    []
  )

  React.useEffect(() => {
    dispatch(FabricInventoryAction.getListPage({ ...params, ...pagination }))
  }, [params, pagination])

  const onChangeFilter = e => {
    setFilter({ ...filter, [e.target.name]: e.target.value })
  }

  const onSearch = () => {
    setPagination({ page: 0, size: 10 })
    setParams({
      ...filter,
      page: 0,
      size: 10,
    })
  }

  return (
    <div className="page-content">
      <ModalDetailRow
        tempDataDetail={tempDataDetail}
        setTempDataDetail={tempDataDetail}
        data={store.fabricInventory.detailPage}
        isOpen={open}
        params={pararmDetail}
        setParams={setPararmDetail}
        selectedId={selectedId}
        selectedToAdd={selectedToAdd}
        setSelectedToAdd={setSelectedToAdd}
        toggle={toggle}
      />
      <Container fluid>
        <Breadcrumbs title={"生地在庫管理"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col md={2}>
                <TextInputWithLabel
                  label={"生地商社"}
                  placeholder={""}
                  value={filter.companyName}
                  type="text"
                  name="companyName"
                  onChange={onChangeFilter}
                />
              </Col>
              <Col md={3}>
                <TextInputWithLabel
                  label={"ブランド"}
                  placeholder={""}
                  value={filter.brand}
                  type="text"
                  name="brand"
                  onChange={onChangeFilter}
                />
              </Col>
              <Col md={3}>
                <TextInputWithLabel
                  label={"バンチ"}
                  placeholder={""}
                  value={filter.bunch}
                  type="text"
                  name="bunch"
                  onChange={onChangeFilter}
                />
              </Col>
              <Col md={3}>
                <TextInputWithLabel
                  label={"生地番号"}
                  placeholder={""}
                  value={filter.number}
                  type="text"
                  name="number"
                  onChange={onChangeFilter}
                />
              </Col>

              <Col md={1} className="align-self-end">
                <SButton className="button" onClick={() => onSearch()}>
                  検索
                </SButton>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Row className="mb-3">
              <Col sm="6" />
              <Col
                sm="6"
                className="d-flex align-items-end justify-content-end"
              >
                <SButton
                  className="mx-2 button"
                  onClick={() => {
                    console.log(selectedToAdd)
                    // const cleanData = [selectedToAdd]
                    // selectedToAdd.forEach(element => {
                    //   cleanData.push(...element.content)
                    // })

                    let selected = selectedToAdd.filter(i => i.selected)
                    if (selected.length < 1) {
                      return toast.error("注文したい生地を選択してください。")
                    }
                    const firstTradingCompanyId =
                      selected[0].fabricTradingCompanyId

                    const checkTradingId = selected.filter(
                      i => i.fabricTradingCompanyId == firstTradingCompanyId
                    )

                    if (selected.length != checkTradingId.length) {
                      return toast.error(
                        "選択したデータをもう一度確ご認ください。"
                      )
                    }

                    console.log(selected)
                    history.push(
                      `/inventory-control/fabric-purchase-management/add`,
                      { data: selected }
                    )
                  }}
                >
                  新規生地発注
                </SButton>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm="12">
                {store.fabricInventory.pageData.loading ? (
                  <Skeleton count={5} />
                ) : store.fabricInventory.pageData.data?.content?.length ===
                  0 ? (
                  <h3 className="text-center">No Data to Display</h3>
                ) : (
                  <>
                    <TableContainer
                      data={store.fabricInventory.pageData.data?.content}
                      columns={columns}
                      pagination
                      page={pagination.page}
                      size={pagination.size}
                      count={
                        store.fabricInventory.pageData.data?.totalPages || 1
                      }
                      setParams={setPagination}
                      params={pagination}
                    />
                  </>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}
